import { render, staticRenderFns } from "./AddStockNext.vue?vue&type=template&id=f37d4242&scoped=true"
import script from "./AddStockNext.vue?vue&type=script&lang=js"
export * from "./AddStockNext.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f37d4242",
  null
  
)

export default component.exports